import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function FileListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.FileListing', {
		url: '/admin/files/listing',
		controllerAs: 'vm',
		controller: FileListingCtrl,
		templateUrl: '/ng/hub/File/Listing/FileListingCtrl.html?' + window.BUILD,
		permission: ['manage_files'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/File/Listing/FileListingCtrl.css'),
			$title: () => 'FileListing page',
		},
	});
}

export class FileListingCtrl {
	constructor($scope, Api, Att) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.Att = Att;
		// setup
		$scope.$watch('vm.filters', this.fetchFiles.bind(this), true);
		this.filters = {
			query: '',
			file_types: undefined,
			sort: '-uploaded_at',
			page: 1,
			limit: 10,
		};
		this.bulkActions = [
			{ id: undefined, name: 'Bulk Actions' },
			{ id: 'delete', name: 'Delete' },
			{ id: 'move', name: 'Move to folder...' },
		];
		this.fileTypes = [
			{ type: undefined, name: 'File type...' },
			{ type: 'doc', name: 'Word Document' },
			{ type: 'xls', name: 'Excel Spreadsheet' },
			{ type: 'ppt', name: 'PowerPoint Presentation' },
			{ type: 'doc,xls,ppt', name: 'Any Office Document' },
			{ type: 'pdf', name: 'PDF' },
			{ type: 'image', name: 'Image' },
			{ type: 'video', name: 'Video' },
			{ type: 'audio', name: 'Audio' },
			{ type: 'zip', name: 'Archive' },
			{ type: 'exe', name: 'Application' },
			{ type: 'other', name: 'Other' },
		];
		this.fetchFiles();
	}

	async fetchFiles() {
		let endpoint;
		this.filters.query = undefined;
		this.files = await this.Api.getPaginated('/files/search', this.filters);
	}

	previewFile(file) {
		this.Att.popupId(file.id);
	}
}
